export default __webpack_public_path__ + "static/media/polygon.aeeb583b.svg";